var app = angular.module("leonardo");

var PropertyGroupListActions = function ($scope, $rootScope, ngDialog, PermissionService, AuthDataService, AccountService,
  AccountUserService) {

  $scope.permissionService = PermissionService;

  $scope.showGroupAddDialog = function () {
    angular.forEach(AuthDataService.authData.user.account_users, function (account) {
      if (account.is_owner)
        $scope.account = account.account;
    });

    ngDialog.openConfirm({
      template: 'views/templates/dialog/group/add.html',
      controller: 'GroupAddDialog',
      data: {
        mode: 'add',
        account: $scope.account ? $scope.account : AccountUserService.currentAccountUser.account
      }
    }).then(function () {
      $rootScope.$broadcast('group:added');
    });

  };

};

app.controller('PropertyGroupListActions', ['$scope', '$rootScope', 'ngDialog', 'PermissionService', 'AuthDataService',
  'AccountService', 'AccountUserService', PropertyGroupListActions]);